import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from "@angular/router";
import { NbToastrService } from "@nebular/theme";
import { Globals } from "../globals";
import { SetupService } from "../services/setup.service";
import * as _ from "underscore";
import * as __ from "lodash";
import { firstValueFrom } from 'rxjs'
import { filter, take } from 'rxjs/operators';
import { getRolesFromJWT } from "src/app/services/utils"


@Injectable({
  providedIn: "root",
})
export class StalkerRoutingGuard implements CanActivate {
  constructor(
    public globals: Globals,
    private setupService: SetupService,
    private toastrService: NbToastrService
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    //v2-let access = this.globals.access;
    console.error("STALKER - canActivate")

    // Wait until userReady$ is true
    await firstValueFrom(
      this.setupService.userReady$.pipe(
        filter(ready => ready)
      )
    );

    // Now safe to use global data
    console.log("STALKER - switchEvaluation")
    return this.switchEvaluation(state);
  }

  async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  
  switchEvaluation(state: RouterStateSnapshot): boolean {
    let access = this.setupService.user.is_admin;
    access = getRolesFromJWT(this.globals.token).includes("stalker")

    switch (state.url) {
      case "/stalker":
        //v2-if (!access.frontend) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      default:
        return false;
    }
  }

  showNotification(message, status, position: any = "bottom-right") {
    this.toastrService.show("", message, { status: status, hasIcon: false, position: position });
  }
}
